import { Typography, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import FunctionalDialog from 'components/Modals/FunctionalDialog';

interface StemRenderingStartedDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const StemRenderingStartedDialog = ({
  isOpen,
  onClose,
}: StemRenderingStartedDialogProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <FunctionalDialog
      submitText={t('download:action:confirm')}
      state={{
        isOpen,
        error: null,
        isLoading: false,
      }}
      title={t('download:stems:rendering:title')}
      action={{
        onSubmit: onClose,
        onClose,
        onExited: () => null,
      }}
      buttonVariant="contained"
      buttonColor="info"
    >
      <Typography sx={{ color: theme.palette.grey[900] }}>
        <Trans i18nKey="download:stems:rendering:description1" />
        <br />
        <br />
        {t('download:stems:rendering:description2')}
      </Typography>
    </FunctionalDialog>
  );
};

export default StemRenderingStartedDialog;
